import { useState } from 'react';
import { auth } from '../../firebase';
import { updatePassword, EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { useAuth } from '../../context/AuthContext';
import Layout from '../../components/ui/Layout';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { toast } from '../../components/ui/Toast';
import { IconLock, IconCheck } from '@tabler/icons-react';

export default function Security() {
  const { user } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);

  const handleChangePassword = async () => {
    if (!currentPassword) { toast.error('Please enter your current password'); return; }
    if (newPassword.length < 8) { toast.error('New password must be at least 8 characters'); return; }
    if (newPassword !== confirmPassword) { toast.error('Passwords do not match'); return; }
    setSaving(true);
    try {
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, newPassword);
      setCurrentPassword(''); setNewPassword(''); setConfirmPassword('');
      toast.success('Password updated');
    } catch (err) {
      console.error(err);
      if (err.code === 'auth/wrong-password') {
        toast.error('Current password is incorrect');
      } else {
        toast.error('Failed to update password');
      }
    }
    setSaving(false);
  };

  return (
    <Layout>
      <div style={{ padding: 'var(--main-padding)', maxWidth: 480, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
          <IconLock size={20} color="var(--color-text-secondary)" stroke={1.5} />
          <h1 style={{ fontSize: 22, fontWeight: 400 }}>Security</h1>
        </div>
        <Card style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 14, fontWeight: 400, marginBottom: 16 }}>Change password</div>
          {[
            { label: 'Current password', value: currentPassword, set: setCurrentPassword, placeholder: '••••••••' },
            { label: 'New password', value: newPassword, set: setNewPassword, placeholder: 'At least 8 characters' },
            { label: 'Confirm new password', value: confirmPassword, set: setConfirmPassword, placeholder: 'Repeat new password' },
          ].map((field, i) => (
            <div key={field.label} style={{ marginBottom: i < 2 ? 12 : 0 }}>
              <label style={{ display: 'block', fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 6 }}>{field.label}</label>
              <input
                type="password"
                placeholder={field.placeholder}
                value={field.value}
                onChange={e => field.set(e.target.value)}
                style={{ width: '100%', boxSizing: 'border-box' }}
              />
            </div>
          ))}
        </Card>
        <Button variant="primary" onClick={handleChangePassword} disabled={saving} loading={saving} icon={<IconCheck size={14} stroke={1.5} />}>
          {saving ? 'Updating...' : 'Update password'}
        </Button>
      </div>
    </Layout>
  );
}